import { connect } from 'react-redux';
//import { Link } from 'react-router-dom';
import Footer from '../VerticalLayout/Footer';
import axios from "axios"
import React, { useEffect, useCallback, useMemo, useState } from "react";
import * as url from "../../api/uri_helper";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Log from "../Authentication/Login";
import Index from "../Dashboard/Index";
import NewVersion from "../UserLogin/NewVersion";
import { getCompnaysitedata } from "../../Redux/Actions/DashboardCount";
import { Skeleton } from 'antd';
import { fetchUserDataByEmailId } from "../../Redux/Api/fetch.api";

const Auth = () => {

    const history = useHistory();
    const [encryptedToken, setEncryptedToken] = useState('');
    const [isChecked, setisActive] = useState(true)
    const dispatch = useDispatch();
    const [isSuccess, setIsSuccess] = useState(false)
    const [siteId, setSiteId] = useState('');

   

    useEffect(() => {
       
        let url = location.pathname
        const parts = url.split('/Access/')[1].split('/');

        if (parts.length >= 3) {
            const encodedEmail = parts[0];
            const encodedCompanyID = parts[1];
            const encodedSiteID = parts[2];

            // Decode the base64-encoded strings
            const decodedEmail = atob(encodedEmail);
            const decodedCompanyID = atob(encodedCompanyID);
            const decodedSiteID = atob(encodedSiteID);
            setSiteId(decodedSiteID); // Save to state

            //  GetCompanyAndSiteData(decodedCompanyID, decodedSiteID)
            RedirectToDashboard(decodedCompanyID, decodedSiteID, decodedEmail);
            getUserByEmailId(decodedEmail)


        } else {
            console.error('Invalid URL format');
        }
    }, []);

    const getUserByEmailId = (emailid) => {
    
        fetchUserDataByEmailId(emailid)
            .then(response => {
              
                if (response.data.success) {
                    const { firstName, lastName } = response.data.data;
                    localStorage.setItem('userName', `${firstName} ${lastName}`);

                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            })

    }
   
    const RedirectToDashboard = async (companyID, siteID, emailID) => {
        let urlData = location.pathname.split('/');
        setEncryptedToken(urlData[2])
        localStorage.setItem('ComingTekaverse', companyID);
        localStorage.setItem('SiteId', siteID);
        localStorage.setItem('emailid', emailID);

        if (urlData) {
            const response = await axios
                .post(url.GET_DECRYPTEDTOKEN,
                    {
                        Token: emailID,

                    })
                .then(response => {
                    if (response.data.success) {
                        setIsSuccess(true)
                        localStorage.setItem('UserId', response.data.data.userId); // New changes
                        localStorage.setItem('isChecked', isChecked ? isChecked : '');
                      //  localStorage.setItem('userName', response.data.data.userName);
                        localStorage.setItem('tekaHelpToken', response.data.data.token);
                        history.push({
                            pathname: "/QR",
                            state: {
                                from: location.pathname,
                                isRedirected: true,
                            },
                        });
                    }
                    else {
                        history.push({
                            pathname: "/VersionUpdate",
                            state: {
                                from: location.pathname,
                            },
                        });
                    }
                })
                .catch((err) => {
                    console.log("Err: ", err);
                });
        }
    }

    return (
        <>
            {isSuccess ? <Index /> : <Skeleton active avatar />}
        </>
    )

};
export default connect()(Auth)
